import State from 'store/State';
import { selectComponentKeysByType } from 'layout/store/selectors';
import { WidgetType } from 'widgets/WidgetType';
import { BlotterWidgetState } from './BlotterWidgetState';
import { selectWidgetInstancesState } from 'widgets/store/selectors';

export const selectBlotterWidgetKeys: (state: State) => string[] = (state) =>
    selectComponentKeysByType(state, WidgetType.BLOTTER);

export const selectBlotterState: (
    state: State,
    widgetKey: string
) => BlotterWidgetState | undefined = (state, widgetKey) =>
    selectWidgetInstancesState(state).blotter[widgetKey];
